<template>
  <div id="contract-editor-preview">
    <print ref="printRef">
      <page>
        <div class="nation">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
        <div class="motto">Độc lập - Tự do - Hạnh phúc</div>
        <br/>
        <div class="hr"/>
        <div class="header">
          <div class="logo-holder">
            <logo-inversed-circle class="icon"/>
            <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
          </div>
          <div class="title-info">
            <span class="bill">HỢP ĐỒNG CẦM CỐ</span>
            <br/><br/>
            <strong class="info">Mã hợp đồng (HĐ): {{ branch.name }}-{{ contract.finfluxId || '••••••' }}</strong><br/>
            <strong class="info">Mã khách hàng (KH): HCMKH-{{ client.finfluxId || '••••••' }}</strong><br/>
          </div>
        </div>
        <br/>
        <br/>
        <br/>
        <span>Ngày {{ moment(contract.disbursedOn, DATE_FORMAT).format('DD-MM-YYYY') }}, tại Công ty TNHH Đầu Tư và Phát Triển Kinh Doanh ICADO, chúng tôi gồm có::</span>
        <br/>
        <br/>
        <b-row>
          <b-col cols="6">
            <span><strong>Bên khách hàng:</strong></span>
            <table>
              <tr>
                <td class="label">Họ và tên:</td>
                <td><span>{{ client.lastName }} {{ client.firstName }}</span></td>
              </tr>
              <tr>
                <td class="label">Số điện thoại:</td>
                <td><span>{{ client.primaryPhoneNumber }}</span></td>
              </tr>
              <tr>
                <td class="label">Sinh ngày:</td>
                <td><span>{{ moment(client.dateOfBirth, DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
              </tr>
              <tr>
                <td class="label">CMND/HC:</td>
                <td><span>{{ client.citizenId }}</span></td>
              </tr>
              <template v-if="!!asset.meta.coOwner">
                <tr>
                  <td class="label">Họ và tên vợ/chồng:</td>
                  <td><span>{{ asset.meta.coOwner }}</span></td>
                </tr>
                <tr>
                  <td class="label">CMND/HC:</td>
                  <td><span>{{ asset.meta.coOwnerCitizenId }}</span></td>
                </tr>
              </template>
              <tr>
                <td class="label">Địa chỉ:</td>
                <td><span>{{ getClientFullAddress(client) }}</span></td>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <span><strong>Bên nhận cầm cố tài sản:</strong></span><br/>
            <span>Công ty TNHH Đầu Tư và Phát triển Kinh Doanh ICADO</span><br/>
            <span>GPKD số: 0313412428</span><br/>
            <span>Địa chỉ: {{ branch.address }}</span>
          </b-col>
        </b-row>

        <br/>
        <br/>
        <div><strong>Hai bên đồng ý thực hiện việc cầm cố tài sản với những thỏa thuận sau:</strong></div>
        <div><strong>I. THỎA THUẬN VỀ ĐỊNH GIÁ TÀI SẢN</strong></div>
        <div><strong>Thông tin tài sản cầm cố (TSCC):</strong></div>
        <br/>
        <ul>
          <table class="contract">
            <tr>
              <td><li>Tài sản cầm cố:</li></td>
              <td><span class="margin-left">{{ $t(assetCategory.key) }}</span></td>
            </tr>
            <tr>
              <td><li>Miêu tả tài sản:</li></td>
              <td><div class="margin-left">{{ asset.description }}</div></td>
            </tr>
            <template v-for="key in Object.keys(asset.meta)">
              <tr v-if="!!asset.meta[key]" :key="key">
                <td><li>{{ $t(camelToUpperSnake(key)) }}:</li></td>
                <td><span class="margin-left">{{ asset.meta[key] }}</span></td>
              </tr>
            </template>
            <tr v-if="asset.isRealEstate">
              <td><li>ĐK cầm đất:</li></td>
              <td><span class="margin-left">Khách hàng xác nhận tài sản chưa từng phát sinh giao dịch mua bán bằng giấy tay với bất kì bên nào</span></td>
            </tr>
            <tr v-else>
              <td><li>Số lượng:</li></td>
              <td><span class="margin-left">01</span></td>
            </tr>
          </table>
        </ul>
        <div><strong>2. Điều kiện cầm:</strong></div>
        <ul>
          <table class="contract">
            <tr>
              <td><li>Giá cầm:</li></td>
              <td><span class="margin-left">{{ addCommas(contract.approvedAmount) }} VNĐ</span></td>
            </tr>
            <tr>
              <td><li>Ngày đáo hạn:</li></td>
              <td><span class="margin-left">{{ moment(contract.maturesOn, DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
            </tr>
            <tr>
              <td><li>Lãi suất trong hạn:</li></td>
              <td><span class="margin-left">1.5 %</span></td>
            </tr>
            <tr>
              <td><li>Phí dịch vụ:</li></td>
              <td><span class="margin-left">{{ (product.commitmentDays > product.loanTerm) ? (contract.interestRate - 1.5 + product.commitmentPenaltyRate) : contract.interestRate - 1.5 }} %</span></td>
            </tr>
            <tr v-show="contract.storageFee > 0">
              <td><li>Phí kho bãi:</li></td>
              <td><div class="margin-left">{{ addCommas(contract.storageFee) }} VNĐ</div></td>
            </tr>
            <!-- TODO: implement promotion -->
          </table>
        </ul>
        <span>
          ICADO sẽ giải ngân bằng tiền mặt cho KH là
          <strong>{{ addCommas(Math.round(contract.disbursementAmount / 1000) * 1000) }} VNĐ</strong>
          {{ contract.isAdvance ? 'đã khấu trừ tiền lãi suất đầu kỳ là' : 'và sẽ thu tiền lãi suất mỗi kỳ là' }}
          <strong>{{ addCommas(Math.round((contract.interestAmount + contract.roundingFee) / 1000) * 1000) }} VNĐ</strong>{{ contract.isAdvance ? '.' : 'vào ngày hết hạn hợp đồng' }}
          <strong>Tôi xác nhận rằng: </strong><i>Tôi đã đọc, hiểu và cam kết tuân thủ theo quy định về quy trình gia hạn hợp đồng mới, quy trình nhắc lãi, quy trình thẩm định thanh lý tài sản. Trong trường hợp tôi vi phạm những quy định trên, Tôi xin chịu hoàn toàn trách nhiệm về sai phạm của mình.</i>
        </span>
        <br/>
        <br/>
        <b-row class="sign">
          <b-col cols="6">
            <center>
              <span>Đại diện ICADO</span><br>
              <span>(Ký, và ghi họ tên)</span>
            </center>
          </b-col>
          <b-col cols="6">
            <center>
              <span>Khách hàng</span><br>
              <span>(Ký, và ghi họ tên)</span>
            </center>
          </b-col>
        </b-row>

        <div class="working-hours">{{ $t('WORKING_HOURS') }}</div>
      </page>

      <page class="terms">
        <div class="uppercase"><strong>II. ĐIỀU KHOẢN CẦM ĐỒ</strong></div>
        <span>Quý khách vui lòng đọc kỹ các quy định dưới đây trước kí HĐ:</span>
        <br/>
        <br/>

        <div><strong>1. Điều kiện cầm:</strong></div>
        <ul>
          <li>HĐ này có giá trị trong vòng {{ product.loanTerm }} ngày. Hết {{ product.loanTerm }} ngày, khách hàng có quyền tất toán hoặc gia hạn HĐ</li>
          <li>Trong trường hợp gia hạn, khách hàng sẽ tiến hành đóng lãi theo quy định của ICADO.</li>
          <li>Trong trường hợp KH gia hạn HĐ, ICADO sẽ thẩm định lại giá trị TSCC theo giá trị tài sản thực tế tại thời điểm gia hạn. Trong trường hợp KH muốn gia hạn mà giá trị tài sản tại thời điểm gia hạn mất giá trị quá 10% thì KH sẽ tiến hành đóng lãi cộng thêm khoản chênh lệch để được tiếp tục gia hạn HĐ.</li>
          <li>Trong trường hợp ICADO và KH đồng ý thỏa thuận, việc gia hạn có thể được thực hiện dưới 2 hình thức:</li>
          <ul style="list-style-type: square;">
            <li>KH đến trực tiếp công ty làm thủ tục.</li>
            <li>KH thực hiện chuyển khoản tiền lãi (thêm khoản chênh lệch nếu có) cộng với xác nhận email/tin nhắn. ICADO sẽ xác nhận gia hạn qua email/tin nhắn.</li>
          </ul>
          <li>KH có thể đóng lãi, tất toán HĐ bằng tiền mặt tại văn phòng hoặc chuyển khoản qua thông tin dưới đây:</li>
          <br/>
          <center>
            <table class="bank">
              <tr>
                <td colspan="2">Ngân hàng Techcombank</td>
              </tr>
              <tr>
                <td>Chủ tài khoản</td>
                <td>Công ty TNHH Đầu tư và Phát triển Kinh Doanh ICADO</td>
              </tr>
              <tr>
                <td>Số tài khoản</td>
                <td>19040127696015</td>
              </tr>
              <tr>
                <td colspan="2">Nội dung: Đóng lãi/tất toán HĐ số {{ contract.finfluxId || '••••••' }}</td>
              </tr>
            </table>
          </center>
          <br/>
          <li>Trường hợp quý khách chuyển khoản không kèm nội dung (bao gồm số HĐ, hoặc họ tên đầy đủ & số điện thoại), Camdonhanh sẽ không chịu trách nhiệm nếu xảy ra sai sót trong quá trình xác nhận gia hạn, tất toán hợp đồng cho quý khách.</li>
        </ul>

        <template v-if="(product.commitmentDays === product.loanTerm)">
          <div><strong>2. Các điều khoản liên quan đến tiền lãi</strong></div>
          <ul>
            <li>Trường hợp KH đóng lãi hoặc tất toán trễ tính từ ngày hết hạn cầm đồ, ICADO sẽ thu thêm tiền lãi ngày theo quy định.</li>
            <li>Trường hợp KH tất toán trước thời hạn cầm, ICADO không hoàn trả lại khoản lãi đã thu trước đó.</li>
          </ul>
        </template>

        <div><strong>{{ (product.commitmentDays === product.loanTerm) ? 3 : 2 }}. Thanh lý tài sản</strong></div>
        <ul>
          <li>Sau 3 ngày kể từ ngày hết hạn cầm cố, nếu KH không hoàn thành nghĩa vụ tất toán HĐ hoặc đóng lãi gia hạn theo Điều 1 của HĐ này, ICADO có quyền nhận chính TSCC để thay thế cho việc thực hiện nghĩa vụ trả nợ của KH.</li>
          <li>Kể từ thời điểm trên, ICADO sẽ có toàn quyền sở hữu và được phép thanh lý TSCC theo quy định nội bộ, đồng thời yêu cầu KH thanh toán số nợ còn thiếu nếu số tiền thu được từ việc thanh lý TSCC không đủ bù đắp vốn đã cho cầm và các chi phí liên quan đến việc thanh lý TSCC của KH.</li>
        </ul>

        <template v-if="(product.commitmentDays === product.loanTerm)">
          <div><strong>4. Cam kết về nguồn gốc tài sản</strong></div>
          <ul>
            <li>KH phải cam kết chịu trách nhiệm hoàn toàn về nguồn gốc hợp pháp của TSCC, cam kết về tính chính hãng, nguyên gốc của TSCC. Trường hợp phát sinh bất kì tranh chấp, khiếu nạn liên quan đến TSCC thì KH có trách nhiệm giải quyết, đồng thời phải hoàn thành nghĩa vụ theo HĐ này và bồi thường từ ICADO toàn bộ chi phí thiệt hại phát sinh.</li>
            <li>KH phải cam kết về tính chính hãng, nguyên gốc của TSCC. Trong trường hợp phát hiện TSCC giả mạo, KH phải chịu trách nhiệm hoàn toàn trước pháp luật đồng thời bồi thường cho ICADO toàn bộ chi phí thiệt hại phát sinh.</li>
          </ul>
        </template>

        <div><strong>{{ (product.commitmentDays === product.loanTerm) ? 5 : 3 }}. Quy định về tất toán HĐ</strong></div>
        <ul>
          <li>Chỉ người đứng tên trên HĐ mới có quyền nhận lại TSCC (mang theo cả giấy CMND và HĐ cầm cố).</li>
          <li>ICADO sẽ bàn giao tài sản còn nguyên tem niêm phong với chữ ký khi KH hoàn tất việc thanh toán tiền gốc và lãi theo HĐ. KH cần thực hiện việc tháo dỡ tem và kiểm tra lại tài sản khi có sự hiện diện của nhân viên công ty. Mọi hư hỏng sau khi tài sản được bàn giao cho KH, ICADO sẽ không chịu trách nhiệm.</li>
          <li>Trường hợp tài sản bị tổn thất do lâu không được sử dụng, ICADO sẽ không chịu trách nhiệm bồi thường.</li>
        </ul>

        <div><strong>{{ (product.commitmentDays === product.loanTerm) ? 6 : 4 }}. Các quy định khác</strong></div>
        <ul>
          <li>Trong trường hợp bị thất lạc, mất mát hoặc hư hại HĐ, KH có trách nhiệm thông báo ngay cho ICADO, chúng tôi sẽ không chịu trách nhiệm với bất kỳ tổn thất nào về tài sản của quý khách khi không xuất trình được HĐ.</li>
          <li>Trong trường hợp ICADO cần mở niêm phong TSCC để kiểm tra ngẫu nhiên tài sản theo quy định của công ty, KH hỗ trợ hiện diện có mặt để đảm bảo việc niêm phong minh bạch.</li>
          <li>Trong trường hợp TSCC bị tổn hại do lỗi bên ICADO, công ty sẽ có trách nhiệm bồi thường cho KH theo thỏa thuận của hai bên.</li>
          <li v-if="asset.isRealEstate">Trong thời gian cầm cố tài sản, nếu KH hoàn thành đúng nghĩa vụ gia hạn HD. ICADO không có quyền đăng bộ tài sản cầm cố được nêu trong Mục I của HD này.</li>
        </ul>

        <template v-if="(product.commitmentDays > product.loanTerm)">
          <div class="uppercase"><strong>III. ĐIỀU KHOẢN ƯU ĐÃI</strong></div>
          <div> <strong>1. Giảm phí dịch vụ</strong></div>
          <ul>
            <li>Áp dụng giảm {{ (product.commitmentPenaltyRate) }}% phí dịch vụ Điều 2 Mục 1 ở Hợp đồng này. Nếu Khách hàng đáp ứng đủ điều kiện chương trình</li>
          </ul>
          <div> <strong>2. Điều kiện áp dụng</strong></div>
          <ul>
            <li>Chỉ áp dụng cho khách cầm từ {{product.commitmentDays}} ngày  trở lên, tính từ ngày: {{ moment(originallySubmittedOn, DATE_FORMAT).format('DD-MM-YYYY') }}</li>
            <li>Nếu tất toán trước ngày {{ moment(originallySubmittedOn, DATE_FORMAT).add(product.commitmentDays, 'days').format('DD-MM-YYYY') }}, Khách hàng cần hoàn trả lại phần ưu đãi  đã được ICADO khấu trừ theo mức phí dịch vụ ở Điều 2 Mục 1 ở Hợp đồng này. VD: với khách cầm 1 tháng, khi tất toán  phải đóng thêm lãi còn thiếu là {{product.commitmentPenaltyRate}}%, 2 tháng là {{product.commitmentPenaltyRate * 2}}%...</li>
          </ul>
        </template>

        <div class="working-hours">{{ $t('WORKING_HOURS') }}</div>
      </page>

      <page v-if="asset.isVehicle" class="vehicle-authorization-letter">
        <div class="nation">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
        <div class="motto">Độc lập - Tự do - Hạnh phúc</div>
        <br/>
        <div class="hr"/>
        <div class="header">
          <div class="logo-holder">
            <logo-inversed-circle class="icon"/>
            <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
          </div>
          <div class="title-info">
            <span class="bill">GIẤY UỶ QUYỀN</span><br/>
            <span class="bill">XE MÁY/Ô TÔ</span>
          </div>
        </div>
        <br/>
        <br/>
        <br/>
        <span>Ngày {{ moment(contract.disbursedOn, DATE_FORMAT).format('DD-MM-YYYY') }}, tại Công ty TNHH Đầu Tư và Phát Triển Kinh Doanh ICADO, chúng tôi gồm có::</span>
        <br/>
        <br/>
        <b-row>
          <b-col cols="6">
            <span><strong>Bên ủy quyền (Bên A):</strong></span>
            <table>
              <tr>
                <td class="label">Họ và tên:</td>
                <td><span>{{ client.lastName }} {{ client.firstName }}</span></td>
              </tr>
              <tr>
                <td class="label">Số điện thoại:</td>
                <td><span>{{ client.primaryPhoneNumber }}</span></td>
              </tr>
              <tr>
                <td class="label">Sinh ngày:</td>
                <td><span>{{ moment(client.dateOfBirth, DATE_FORMAT).format('DD-MM-YYYY') }}</span></td>
              </tr>
              <tr>
                <td class="label">CMND/HC:</td>
                <td><span>{{ client.citizenId }}</span></td>
              </tr>
              <tr>
                <td class="label">Địa chỉ:</td>
                <td><span>{{ getClientFullAddress(client) }}</span></td>
              </tr>
            </table>
          </b-col>
          <b-col cols="6">
            <span><strong>Bên được ủy quyền (Bên B):</strong></span><br/>
            <span>Công ty TNHH Đầu Tư và Phát triển Kinh Doanh ICADO</span><br/>
            <span>GPKD số: 0313412428</span><br/>
            <span>Địa chỉ: {{ branch.address }}</span>
          </b-col>
        </b-row>
        <br/>
        <br/>
        <div class="uppercase"><strong>I. THỎA THUẬN VỀ ĐỊNH GIÁ TÀI SẢN</strong></div>
        <span>Trong trường hợp Bên A không hoàn thành nghĩa vụ đóng lãi hoặc chuộc xe máy/ô tô đúng thời hạn đã được thể hiện trong hợp đồng cầm cố số: {{ branch.name }}-{{ contract.finfluxId || '••••••' }} thì Bên A ủy quyền cho Bên B toàn quyền sở hữu và quyết định (bán, sang tên, ...) xe máy/ô tô được thể hiện trong hợp đồng cầm cố số: {{ branch.name }}-{{ contract.finfluxId || '••••••' }}. Thông tin xe máy/ô tô cụ thể như sau:</span>
        <table class="authorized">
          <tr>
            <td><strong>{{ $t('CHASSIS_ID') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.chassisId }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('ENGINE_ID') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.engineId }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('BRAND') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.brand }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('PRODUCT_LINE') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.productLine }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('COLOR') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.color }}</strong></td>
          </tr>
          <tr>
            <td><strong>{{ $t('LICENSE_PLATE_ID') }}:</strong></td>
            <td><strong class="margin-left">{{ asset.meta.licensePlateId }}</strong></td>
          </tr>
        </table>
        <br/>
        <div class="uppercase"><strong>II. CAM KẾT</strong></div>
        <span>Hai bên cam kết sẽ hoàn toàn chịu trách nhiệm trước Pháp luật về mọi thông tin ủy quyền ở trên. Giấy ủy quyền trên được lập thành 2 bản, mổi bên giữ 1 bản và có hiệu lực ngang nhau.</span>
        <br/>
        <b-row class="sign">
          <b-col cols="6">
            <center>
              <span>Bên ủy quyền</span><br>
              <span>(Ký, và ghi họ tên)</span>
            </center>
          </b-col>
          <b-col cols="6">
            <center>
              <span>Bên được ủy quyền</span><br>
              <span>(Ký, và ghi họ tên)</span>
            </center>
          </b-col>
        </b-row>
      </page>

      <page class="receipts" v-if="!review">
        <template v-for="index in 2">
          <div :key="index">
            <div class="nation">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
            <div class="motto">Độc lập - Tự do - Hạnh phúc</div>
            <br/>
            <div class="hr"/>
            <div class="header">
              <div class="logo-holder">
                <logo-inversed-circle class="icon"/>
                <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
              </div>
              <div class="title-info">
                <span class="bill">{{ contract.renewalAmount > 0 ? 'PHIẾU THU' : 'PHIẾU CHI' }}</span>
                <br/>
                <strong class="info">Mã hợp đồng (HĐ): {{ branch.name }}-{{ contract.finfluxId || '••••••' }}</strong><br/>
                <strong class="info">Mã khách hàng (KH): HCMKH-{{ client.finfluxId || '••••••' }}</strong><br/>
                <strong class="info">Kho bãi: {{ storage.name }}</strong><br/>
              </div>
            </div>
            <table class="bill">
              <tr>
                <td>Ngày lập phiếu:</td>
                <td><span class="margin-left">{{ moment().format('DD-MM-YYYY, HH:mm') }}</span></td>
              </tr>
              <tr>
                <td><strong>Ngày gia hạn:</strong></td>
                <td><strong class="margin-left">{{ moment(contract.disbursedOn, DATE_FORMAT).format('DD-MM-YYYY') }}</strong></td>
              </tr>
              <tr>
                <td><strong>Họ và tên (KH):</strong></td>
                <td><strong class="margin-left">{{ `${client.lastName} ${client.firstName}` }}</strong></td>
              </tr>
              <tr>
                <td>Số điện thoại:</td>
                <td><span class="margin-left">{{ client.primaryPhoneNumber }}</span></td>
              </tr>
              <tr>
                <td>Địa chỉ:</td>
                <td><span class="margin-left">{{ getClientFullAddress(client) }}</span></td>
              </tr>
              <tr>
                <td><strong>Lý do:</strong></td>
                <td v-if="!!contract.renewalAmount"><strong class="margin-left">Đóng HĐ số {{ formerContract.finfluxId }}, mở HĐ số {{ contract.finfluxId || '••••••' }}</strong></td>
                <td v-else><strong class="margin-left">Mở HĐ số {{ contract.finfluxId || '••••••' }}</strong></td>
              </tr>
              <tr>
                <td><strong>Hình thức thanh toán:</strong></td>
                <td><strong class="margin-left">{{ filteredTransactions.length ? $t(filteredTransactions[0].type) : '' }}</strong></td>
              </tr>
              <tr v-if="!!contract.renewalAmount">
                <td><strong>Số tiền gia hạn:</strong></td>
                <td><strong class="margin-left">{{ addCommas(Math.round((Math.abs(contract.renewalAmount - (contract.storageFee || 0)) / 1000) * 1000)) }} VNĐ</strong></td>
              </tr>
              <tr>
                <td><strong>Tiền kho bãi:</strong></td>
                <td v-if="contract.renewalAmount < 0"><strong class="margin-left">({{ addCommas(contract.storageFee) }}) VNĐ</strong></td>
                <td v-else><strong class="margin-left">{{ addCommas(contract.storageFee) }} VNĐ</strong></td>
              </tr>
              <tr v-if="previouslyRepaidAmount > 0">
                <td><strong>Đã thanh toán trước:</strong></td>
                <td><strong class="margin-left">({{ addCommas(previouslyRepaidAmount) }}) VNĐ</strong></td>
              </tr>
              <tr>
                <td><strong>Tổng tiền:</strong></td>
                <td><strong class="margin-left">{{ addCommas(totalAmount) }} VNĐ</strong></td>
              </tr>
              <!-- TODO: implement discount -->
              <tr v-if="contract.receivedAmount > 0">
                <td><strong>Tổng tiền thu được:</strong></td>
                <td><strong class="margin-left">{{ addCommas(Math.round(contract.receivedAmount / 1000) * 1000 - previouslyRepaidAmount) }} VNĐ</strong></td>
              </tr>
              <tr v-if="contract.storageFeeLate > 0">
                <td><strong>Phí kho bãi trễ:</strong></td>
                <td><strong class="margin-left">{{ addCommas(Math.round(contract.storageFeeLate / 1000) * 1000) }} VNĐ</strong></td>
              </tr>
            </table>
            <b-row class="sign">
              <b-col cols="6">
                <center>
                  <strong>Người nộp tiền</strong><br>
                  <strong>(Ký và ghi rõ họ tên)</strong>
                </center>
              </b-col>
              <b-col cols="6">
                <center>
                  <strong>Người lập phiếu</strong><br>
                  <strong>(Ký và ghi rõ họ tên)</strong>
                </center>
              </b-col>
            </b-row>
          </div>
          <div :key="`${index}-divider`" v-if="index==1" class="divider"/>
        </template>
      </page>
      <template v-for="previousTransaction in previousTransactions">
        <page :key="previousTransaction.id" class="receipts" v-if="!review && previousTransactions.length">
          <div v-for="index in 2" :key="index">
            <div>
              <div class="nation">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
              <div class="motto">Độc lập - Tự do - Hạnh phúc</div>
              <br/>
              <div class="hr"/>
              <div class="header">
                <div class="logo-holder">
                  <logo-inversed-circle class="icon"/>
                  <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
                </div>
                <div class="title-info">
                  <span class="bill">{{ 'PHIẾU THU' }}</span>
                  <br/>
                  <strong class="info">Mã hợp đồng (HĐ): {{ branch.name }}-{{ contract.finfluxId || '••••••' }}</strong><br/>
                  <strong class="info">Mã khách hàng (KH): HCMKH-{{ client.finfluxId || '••••••' }}</strong><br/>
                  <strong class="info">Kho bãi: {{ storage.name }}</strong><br/>
                </div>
              </div>
              <table class="bill">
                <tr>
                  <td>Ngày lập phiếu:</td>
                  <td><span class="margin-left">{{ previousTransaction.registeredOn }}</span></td>
                </tr>
                <tr>
                  <td><strong>Ngày gia hạn:</strong></td>
                  <td><strong class="margin-left">{{ moment(contract.disbursedOn, DATE_FORMAT).format('DD-MM-YYYY') }}</strong></td>
                </tr>
                <tr>
                  <td><strong>Họ và tên (KH):</strong></td>
                  <td><strong class="margin-left">{{ `${client.lastName} ${client.firstName}` }}</strong></td>
                </tr>
                <tr>
                  <td>Số điện thoại:</td>
                  <td><span class="margin-left">{{ client.primaryPhoneNumber }}</span></td>
                </tr>
                <tr>
                  <td>Địa chỉ:</td>
                  <td><span class="margin-left">{{ getClientFullAddress(client) }}</span></td>
                </tr>
                <tr>
                  <td><strong>Lý do:</strong></td>
                  <td><strong class="margin-left">Thanh toán một phần HĐ số {{ formerContract.finfluxId }}</strong></td>
                </tr>
                <tr>
                  <td><strong>Hình thức thanh toán:</strong></td>
                  <td><strong class="margin-left">{{ $t(previousTransaction.type) }}</strong></td>
                </tr>
                <tr>
                  <td><strong>Số tiền thu được:</strong></td>
                  <td><strong class="margin-left">{{ addCommas(Math.round(parseFloat(parseFloat(previousTransaction.amount).toFixed(3)) * 1000) * 1000) }} VNĐ</strong></td>
                </tr>
              </table>
              <b-row class="sign">
                <b-col cols="6">
                  <center>
                    <strong>Người nộp tiền</strong><br>
                    <strong>(Ký và ghi rõ họ tên)</strong>
                  </center>
                </b-col>
                <b-col cols="6">
                  <center>
                    <strong>Người lập phiếu</strong><br>
                    <strong>(Ký và ghi rõ họ tên)</strong>
                  </center>
                </b-col>
              </b-row>
            </div>
            <div :key="`${index}-divider`" class="divider"/>
          </div>
        </page>
      </template>
    </print>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import moment from 'moment';

import { DISPLAY_DATE_FORMAT, DATE_FORMAT } from '@/consts';
import { addCommas, camelToUpperSnake } from '@/helpers';

import Print from '@/components/Print';
import Page from '@/components/Page';
import LogoInversedCircle from '@/components/LogoInversedCircle';

const { useState: useAppState } = createNamespacedHelpers('app');
const { useState: useUserState } = createNamespacedHelpers('user');

export default {
  name: 'ContractEditorPreview',
  components: {
    Print,
    Page,
    LogoInversedCircle
  },
  props: {
    client: {
      type: Object,
      default: () => {}
    },
    asset: {
      type: Object,
      default: () => {}
    },
    contract: {
      type: Object,
      default: () => {}
    },
    formerContract: {
      type: Object,
      default: () => {}
    },
    review: {
      type: Boolean,
      default: false
    },
    allTransactions: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { branch: branchName } = useUserState(['branch']);
    const { branches, assetCategories, products, storages } = useAppState(['branches', 'locations', 'assetCategories', 'products', 'storages']);

    const asset = computed(() => props.asset);
    const contract = computed(() => props.contract);
    const branch = computed(() => (branches.value.find((b) => {
      if (contract.value && contract.value.id) {
        return (b.id === contract.value.branchId);
      }

      return (b.name === branchName.value);
    }) || {}));
    const assetCategory = computed(() => assetCategories.value.find((c) => c.id === asset.value.categoryId) || {});
    const product = computed(() => products.value.find((p) => p.id === contract.value.productId) || {});
    const storage = computed(() => storages.value.find((s) => s.id === asset.value.storageId) || {});

    const filteredTransactions = computed(() => (props.allTransactions.filter((item) => item.actions !== 'WAIVE' && item.status !== 'RETRACTED' && !item.isRenewalDifference)));

    const previousTransactions = computed(() => (filteredTransactions.value.slice(1)));
    const previouslyRepaidAmount = computed(() => previousTransactions.value.reduce((p, t) => p + Math.round(parseFloat(parseFloat(t.amount).toFixed(3)) * 1000) * 1000, 0));

    const totalAmount = computed(() => {
      let amount = Math.round((Math.abs(contract.value.renewalAmount) || contract.value.disbursementAmount) / 1000) * 1000;
      if (previouslyRepaidAmount.value > 0) {
        amount -= previouslyRepaidAmount.value;
      }

      return amount;
    });

    const originallySubmittedOn = computed(() => contract.value.originallySubmittedOn || contract.value.disbursedOn);

    const printRef = ref(null);

    const getClientFullAddress = (client) => {
      const { address } = client;
      // as business requires, return only address line
      return address;
    };

    const print = () => {
      printRef.value.print();
    };

    return {
      moment,
      branch,
      assetCategory,
      DISPLAY_DATE_FORMAT,
      DATE_FORMAT,
      getClientFullAddress,
      addCommas,
      camelToUpperSnake,
      product,
      printRef,
      print,
      storage,
      totalAmount,
      filteredTransactions,
      previouslyRepaidAmount,
      previousTransactions,
      originallySubmittedOn
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#contract-editor-preview {
  padding: 20px;

  .terms {
    font-size: 12.5px;
    padding: 7mm 10mm 7mm 10mm;
  }

  .vehicle-authorization-letter {
    font-size: 14px;
    padding: 5mm 10mm 5mm 10mm;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .hr {
    border: 1px solid $iron;
    width: 320px;
    margin: 0px auto;
  }

  .nation {
    size: 13px;
    text-align: center;
  }

  .motto {
    size: 11px;
    line-height: 18px;
    text-align: center;
  }

  .header {
    margin-top: 30px;
    position: relative;

    .logo-holder {
      position: absolute;
      top: 5px;
      left: 0;

      .left {
        padding-left: 26px;
        padding-top: 7px;
      }

      .icon {
        color: $alizarinCrimson;
        height: 80px;
        width: 80px;
      }

      .camdo {
        font-size: 15px;
        color: $carmine;
        font-family: 'Source Sans Pro', Tahoma, Arial;
      }

      .nhanh {
        font-size: 15px;
        color: $alizarinCrimson;
      }
    }

    .title-info {
      text-align: center;
      width: 100%;
    }

    .bill {
      text-transform: uppercase;
      font-weight: bolder;
      font-size: 24px;
    }

    .info {
      font-size: 13px;
    }
  }

  ul {
    list-style-type: circle;
  }

  table {
    width: 100%;
    border-spacing: 0;

    &.authorized {
      margin-top: 35px;
      tr {
        td {
          &:first-child {
            width: 115px;
          }
        }
      }
    }

    &.contract {
      tr {
        td {
          &:first-child {
            width: 120px;
          }
        }
      }
    }

    &.bank {
      border: 1px solid $black;
      border-collapse: collapse;
      width: 478px;

      tr {
        td {
          border: 1px solid $black;
          border-collapse: collapse;
          padding: 3px;
        }
      }
    }

    .margin-left {
      margin-left: 50px;
    }

    td {
      &.label {
        width: 120px;
        vertical-align: top;
      }
    }

    &.bill {
      margin-top: 50px;
      tr {
        td {
          &:first-child {
            width: 150px;
          }
        }
      }
    }
  }

  .sign {
    margin-top: 20px;
  }

  .divider {
    height: 0;
    border-bottom: 1px dashed $alto;
    width: calc(100% + 20mm);
    margin-left: -10mm;
    margin-top: 80px;
    margin-bottom: 20px;
  }

  .receipts {
    .header {
      margin-top: 15px;
    }

    table.bill {
      margin-top: 15px;
    }
  }
}
</style>
